import styled from '@emotion/styled';

export const ConsentMessage = styled.div`
  & a {
    cursor: pointer;
  }
`;
